// Shared mutable state across scenes (replaces the global `gameState`
// object the demo defined in Game.js).
export const gameState = {
  bgMusic: null,
};
